module.exports = __webpack_public_path__ + "img/33.fixed_fluid_taps.ee8c6fdb.svg";